"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filterPlaceTypes_1 = require("../utils/filterPlaceTypes");
var string_1 = require("../utils/string");
var constants_1 = require("./constants");
var routes_1 = require("./routes");
// tslint:disable-next-line:max-classes-per-file
var LodgingUrlGenerator = /** @class */ (function () {
    function LodgingUrlGenerator(compiler) {
        this.route = routes_1.poisRoutes.detail;
        this.toUrl = compiler(this.route);
    }
    LodgingUrlGenerator.prototype.generate = function (poi) {
        return this.toUrl({
            id: poi.id,
            placeId: poi.containingPlaceId,
            slug: this.slug(poi.containingPlaces, poi),
            type: constants_1.poiTypeSlugMap.lodging,
        });
    };
    LodgingUrlGenerator.prototype.slug = function (places, poi) {
        var parts = places.filter(filterPlaceTypes_1.filterPlaceTypes)
            .map(function (p) { return p.name; })
            .reverse();
        parts.push(constants_1.poiTypes.sleeping.displayName);
        parts.push(poi.name);
        // Clean up, and filter out names that returned empty
        return parts.map(function (p) { return string_1.cleanString(p.toLowerCase()); })
            .filter(function (p) { return p; });
    };
    return LodgingUrlGenerator;
}());
exports.LodgingUrlGenerator = LodgingUrlGenerator;



//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-routing/dist/details/lodging.js
// module id = wU4d
// module chunks = 2